import { render, staticRenderFns } from "./WorkingMemory.vue?vue&type=template&id=4957df79&scoped=true&"
import script from "./WorkingMemory.vue?vue&type=script&lang=js&"
export * from "./WorkingMemory.vue?vue&type=script&lang=js&"
import style0 from "./WorkingMemory.vue?vue&type=style&index=0&id=4957df79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957df79",
  null
  
)

/* custom blocks */
import block0 from "./WorkingMemory.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports